module.exports = __webpack_public_path__ + "img/banner-lifeHelp.95acdffd.png";